import { Loader } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useReservationsAsPax } from '@/hooks/api-hooks';
import ReservationsList from '@/components/reservations-list';
import type { Person } from '@turizi/shared';

interface Props {
    person: Person;
}

export default function PersonReservationsTab({ person }: Props): JSX.Element {
    const {
        data: reservationsAsPaxData,
        isLoading: isLoadingReservationsAsPax
    } = useReservationsAsPax(String(person.id));
    const reservationsAsPax = reservationsAsPaxData?.data || [];
    const { t } = useTranslation();

    return (
        <div className="space-y-6">
            <div className="text-sm font-semibold mb-4 flex items-center gap-2">
                {t('reservations_as_passenger')}
                {isLoadingReservationsAsPax && <Loader size="xs" color='black' />}
            </div>
            {reservationsAsPax.length > 0 ? (
                <ReservationsList
                    showFilters={false}
                    reservations={reservationsAsPax}
                    displayOptions={{
                        showClientName: true,
                        showProvider: true,
                        showCoordinator: true,
                        editable: false,
                        groupByPaxs: false,
                        showPaxName: true,
                        showPaxs: true,
                        showPrice: true,
                        showPaymentStatus: true,
                        selectedAttrKeys: []
                    }}
                />
            ) : (
                <div className="text-xs text-gray-400 italic">
                    {t('no_reservations_as_passenger')}
                </div>
            )}
        </div>
    );
}
